var map = {
	"./de.json": 584780,
	"./en.json": 278344,
	"./es.json": 211092,
	"./fr.json": 256822,
	"./it.json": 251311,
	"./ja.json": 962435,
	"./ko.json": 888108,
	"./pl.json": 593340,
	"./pt.json": 658889,
	"./ru.json": 681396,
	"./uk.json": 430412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 538225;